export const sidebarConfig = {
    playlistShortcutLimit: 50
};
